import localesEn from '@/views/Auth/i18n/localeEn';

const translations = {
  en: {
    ...localesEn.en,

    SEO_TITLE: 'Forgot your password?',
    SEO_DESCRIPTION: "Don't worry. It happens to everyone.",
    FORM_TITLE: 'Reset Password',
    FORM_DESCRIPTION:
      "Enter the email address you used when you signed up and we'll send you instructions to reset your password.",
    INPUT_EMAIL_LABEL: 'Email',
    INPUT_EMAIL_HINT: 'Enter your email',
    BUTTON_SUBMIT_LABEL: 'Submit',
    SUCCESS_TITLE: 'Done!',
    SUCCESS_DESCRIPTION:
      "We've just sent an email with instructions to \n [{{email}}](mailto:{{email}}). Follow the instructions to reset your password.",
    BUTTON_SUCCESS_LABEL: 'Sign In',
  },
};

export default translations;
